import React, { useEffect, useState } from 'react';
import { Modal, Button } from "antd";

import PdfJurados2026 from "../../assets/Condiciones generales 1a convocatoria banco de jurados 2026_CB_ DP_AF_Final.pdf";
import PdfLEP2026 from "../../assets/Condiciones_generales_LEP_2026.pdf";
import PdfOrdi2026 from "../../assets/Condiciones_generales_ordinario_2026_modificado.pdf";

interface IProps {
  visualizar: boolean;
  setVisualizar: any;
  nombre: any;
}

export const ModalCondicionesGenerales: React.FC<IProps> = (props: IProps) => {
  const onCancel = () => {
    props.setVisualizar(false);
  };

  const [documentoAbierto, setDocumentoAbierto] = useState(false);
  const [hasScrolledEnd, setHasScrolledEnd] = useState(false);
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (scrollTop + clientHeight >= scrollHeight - 15) {
      setHasScrolledEnd(true);
    }
  };

  useEffect(() => {
    if (!props.visualizar) {
      setDocumentoAbierto(false);
      setHasScrolledEnd(false);
    }
  }, [props.visualizar]);

  let pdfSrc = PdfOrdi2026;
  if (props.nombre == null || props.nombre.includes("Banco de jurados")) {
    pdfSrc = PdfJurados2026;
  } else if (props.nombre.includes("Ley de espectáculos públicos")) {
    pdfSrc = PdfLEP2026;
  }

  return (
    <Modal
      className="modal-condiciones-generales"
      maskStyle={{ backgroundColor: "rgba(15, 23, 42, 0.65)" }}
      visible={props.visualizar}
      closable={true}
      maskClosable={true}
      keyboard={true}
      onCancel={onCancel}
      width={isMobile ? "95vw" : 880}
      style={isMobile ? { maxWidth: "95vw", margin: "16px auto", top: 16 } : { top: 32 }}
      title={
        <div style={{ display: "flex", alignItems: "center", gap: "12px", paddingRight: "28px" }}>
          <div
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "8px",
              backgroundColor: "#eff6ff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#173365",
              flexShrink: 0,
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14 2 14 8 20 8" />
              <line x1="16" y1="13" x2="8" y2="13" />
              <line x1="16" y1="17" x2="8" y2="17" />
              <polyline points="10 9 9 9 8 9" />
            </svg>
          </div>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: "16px", fontWeight: 700, color: "#0f172a", lineHeight: 1.25 }}>
              Condiciones Generales de Participación
            </div>
            <div style={{ fontSize: "12.5px", color: "#64748b", fontWeight: 500, marginTop: "2px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {props.nombre || "Términos y lineamientos oficiales"}
            </div>
          </div>
        </div>
      }
      footer={[
        <a
          key="link-ver-todo"
          href={pdfSrc}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none", marginRight: "8px" }}
          onClick={() => setDocumentoAbierto(true)}
        >
          <Button
            key="B_VER_TODO"
            style={{
              backgroundColor: "#ffffff",
              borderColor: "#cbd5e1",
              color: "#334155",
              fontWeight: 500,
              fontSize: "13.5px",
              height: "38px",
              padding: "0 16px",
              borderRadius: "8px",
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
              <polyline points="15 3 21 3 21 9" />
              <line x1="10" y1="14" x2="21" y2="3" />
            </svg>
            Ver documento completo
          </Button>
        </a>,
        <Button
          key="B_CERRAR"
          type="primary"
          onClick={onCancel}
          style={{
            backgroundColor: "#173365",
            borderColor: "#173365",
            color: "#ffffff",
            fontWeight: 600,
            fontSize: "14px",
            height: "38px",
            padding: "0 24px",
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(23, 51, 101, 0.15)",
          }}
        >
          Cerrar
        </Button>,
      ]}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        {/* Banner informativo */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: "10px",
            padding: "10px 14px",
            backgroundColor: "#f8fafc",
            border: "1px solid #e2e8f0",
            borderRadius: "8px",
          }}
        >
          <div style={{ fontSize: "13px", color: "#475569", lineHeight: 1.4 }}>
            {isMobile
              ? "Revisa las condiciones generales oficiales abriendo el documento completo."
              : "Desliza para consultar el documento o ábrelo en pantalla completa en una nueva pestaña."}
          </div>
          <a
            href={pdfSrc}
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontSize: "13px", fontWeight: 600, color: "#173365", display: "inline-flex", alignItems: "center", gap: "4px" }}
            onClick={() => setDocumentoAbierto(true)}
          >
            Abrir PDF
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </a>
        </div>

        {/* Visor de documento */}
        {isMobile ? (
          <div
            style={{
              textAlign: "center",
              padding: "24px 16px",
              border: "1px solid #e2e8f0",
              borderRadius: "8px",
              backgroundColor: "#f8fafc",
            }}
          >
            <div
              style={{
                width: "52px",
                height: "52px",
                borderRadius: "50%",
                backgroundColor: "#eff6ff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 12px auto",
                color: "#173365",
              }}
            >
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="16" y1="13" x2="8" y2="13" />
                <line x1="16" y1="17" x2="8" y2="17" />
                <polyline points="10 9 9 9 8 9" />
              </svg>
            </div>
            <h4 style={{ fontSize: "15px", fontWeight: 700, color: "#0f172a", marginBottom: "4px" }}>
              Documento de Condiciones Generales
            </h4>
            <p style={{ fontSize: "13px", color: "#64748b", marginBottom: "18px", lineHeight: 1.5, maxWidth: "320px", margin: "0 auto 18px auto" }}>
              Abre el archivo PDF oficial para leer todos los requisitos, lineamientos y causales de la convocatoria.
            </p>
            <a
              href={pdfSrc}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setDocumentoAbierto(true)}
            >
              <Button
                type="primary"
                style={{
                  backgroundColor: "#173365",
                  borderColor: "#173365",
                  color: "#ffffff",
                  fontWeight: 600,
                  fontSize: "14px",
                  height: "40px",
                  padding: "0 22px",
                  borderRadius: "8px",
                  boxShadow: "0 2px 4px rgba(23, 51, 101, 0.15)",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                  <polyline points="15 3 21 3 21 9" />
                  <line x1="10" y1="14" x2="21" y2="3" />
                </svg>
                Ver documento completo (PDF)
              </Button>
            </a>
          </div>
        ) : (
          <div
            onScroll={handleScroll}
            style={{
              height: "540px",
              overflowY: "auto",
              border: "1px solid #e2e8f0",
              borderRadius: "8px",
              backgroundColor: "#f8fafc",
            }}
          >
            <iframe
              src={pdfSrc}
              style={{ width: "100%", height: "100%", minHeight: "535px", border: "none" }}
              title="Condiciones generales"
            />
          </div>
        )}
      </div>
    </Modal>
  );
};
